import React, { useState } from 'react';
import { Alert, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import { EntityEditDialog } from '@lp/lp-ui';

interface BulkMfaOnOffDialogProps {
    open: boolean;
    onClose: () => void;
    onSave: (enableMfa: boolean) => void;
}

const BulkMfaOnOffDialog: React.FC<BulkMfaOnOffDialogProps> = ({ open, onClose, onSave }) => {
    const [selected, setSelected] = useState<string>('');

    const handleClose = () => {
        setSelected('');
        onClose();
    };

    const handleSave = () => {
        onSave(selected === 'on');
        setSelected('');
    };

    return (
        <EntityEditDialog
            open={open}
            maxWidth="sm"
            fullWidth
            title="MFA On/Off"
            handleClose={handleClose}
            handleSave={handleSave}
            editing={true}
            disableSave={!selected}
        >
            <Alert severity="info" sx={{ mb: 2 }}>
                This action will be executed in the background and it may take some time for all changes to take effect.
            </Alert>
            <FormControl>
                <FormLabel>Action</FormLabel>
                <RadioGroup value={selected} onChange={(e) => setSelected(e.target.value)}>
                    <FormControlLabel value="on" control={<Radio />} label="MFA On" />
                    <FormControlLabel value="off" control={<Radio />} label="MFA Off" />
                </RadioGroup>
            </FormControl>
        </EntityEditDialog>
    );
};

export default BulkMfaOnOffDialog;
